export default function initWebinarBanner() {
    const now = new Date().getTime();

    const dateRange = {
      start: new Date(Date.parse('2025-02-18T09:00:00.000Z')).getTime(),
      end: new Date(Date.parse('2025-02-26T17:00:00.000Z')).getTime(),
    };
    const show = now >= dateRange.start && now < dateRange.end;
  
    if (show) {
      $('.webinar-banner').show();
      $('body').addClass('banner-event');
    } else {
      $('.webinar-banner').hide();
      $('body').removeClass('banner-event');
    }
  }
  